import Vue from 'vue'
import Router from 'vue-router'

const appIndex = r => require.ensure([], () => r(require('@/view/home/index.vue')), 'home_components');
const home = r => require.ensure([], () => r(require('@/view/home.vue')), 'home_components');
const biz = r => require.ensure([], () => r(require('@/view/home/biz.vue')), 'home_components');
const program = r => require.ensure([], () => r(require('@/view/miniprogram/program.vue')), 'home_components');
const echarts = r => require.ensure([], () => r(require('@/view/echarts/line.vue')), 'home_components');

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: home,
            redirect: '/index',
            meta: {
                title: 'Labaic智慧实验室系统 十衍淘科技官网'
            },
        },
        {path: '/index', component: appIndex, meta: {title: 'Labaic智慧实验室系统 十衍淘科技官网'}},
        {
            path: '/program',
            component: program,
            name:'program',
            meta: {
                title: '扫码'
            },
         },
        {
            path: '/biz',
            name: 'biz',
            component: biz,
            meta: {
                title: 'Labaic智慧实验室系统 十衍淘科技官网'
            },
        },
        {
            path: '/echarts',
            name: 'echarts',
            component: echarts,
            meta: {
                title: '数据报表'
            },
        },
    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js